// src/Pages/FAQ.js
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const faqs = [
  {
    question: "What makes VintariAI different from other AI tools?",
    answer:
      "Most AI tools give generic answers. VintariAI is built as a private co-strategist, designed for executives and innovators. It delivers board-ready outputs, strategic frameworks, and stress-tests your ideas so you can act with conviction."
  },
  {
    question: "Is my data private and secure?",
    answer:
      "Yes. VintariAI is designed with zero-leakage in mind. Your chats are tied only to your account, stored securely, and never used to train models. We enforce row-level security, HTTPS transport, and Supabase Auth. No admin has access to your strategy data."
  },
  {
    question: "Does VintariAI train on my data?",
    answer:
      "No. Unlike free consumer AI apps, VintariAI does not use your conversations for training. Your strategic insights remain fully private."
  },
{
  question: "Can my team use VintariAI together?",
  answer: (
    <span>
      Yes. Teams can collaborate through corporate plans with seat-based access and centralized billing. 
      Each member still keeps a private workspace, while your organization manages billing and access in one place. 
      To explore corporate options,&nbsp;
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLScYdVuvpyoKV3q04QaVoedAXePxGFOVeTP5uUC0EOFIpyNkYA/viewform?usp=header"
        target="_blank"
        rel="noopener noreferrer"
        className="text-purple-400 hover:text-purple-300 underline"
      >
        Contact sales
      </a>.
    </span>
  )
},
  {
    question: "How fast will I get results?",
    answer:
      "VintariAI is designed to cut through uncertainty in under a minute. Leaders use it to reframe challenges, model scenarios, and generate executive-ready outputs instantly, faster than a consulting workshop."
  },
{
  question: "Can I cancel anytime?",
  answer:
    "Yes. You can cancel your subscription at any time. Access will continue until the end of your billing period. To cancel, please send us a message through the contact form so we can process your cancellation."
},
  // 🔥 Additional High-Value Questions
  {
    question: "How is VintariAI different from ChatGPT or other general AI tools?",
    answer:
      "Unlike generic AI tools, VintariAI is purpose-built for strategy. It uses structured thinking modes, ROI testing, and executive frameworks that align with real decision-making, delivering insights you can act on immediately."
  },
  {
    question: "What support do I get with my subscription?",
    answer:
      "Both Professional and Elite users receive support through the contact form. Elite users also benefit from priority responses, dedicated onboarding, and direct access for feature requests or tailored solutions."
  },
  {
    question: "Does VintariAI comply with GDPR and CCPA?",
    answer:
      "Yes. VintariAI is built to meet GDPR and CCPA standards. You can export or permanently delete your data at any time through your account settings."
  },
  {
    question: "What happens if I exceed my plan limits?",
    answer:
      "Free users are capped daily. Professional and Elite plans increase message and feature limits. If you hit a cap, you’ll be prompted to upgrade instantly without losing your chat history."
  },
  {
    question: "Can VintariAI integrate with my enterprise tools?",
    answer:
      "Enterprise users can request integrations for tools like Slack, Notion, or Microsoft Teams. Our roadmap includes enterprise connectors to embed VintariAI directly in your workflow."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <section className="flex-grow py-16 px-6 max-w-4xl mx-auto w-full">
        {/* Top bar with Return Home on left and title centered */}
        <div className="relative mb-10">
          <button
            onClick={() => navigate("/")}
            className="absolute left-0 top-0 bg-white/10 hover:bg-white/20 transition px-4 py-2 rounded-lg text-sm"
          >
            ← Return Home
          </button>
          <h2 className="text-3xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-500">
            Frequently Asked Questions
          </h2>
        </div>

{/* FAQ List */}
<div className="space-y-4">
  {faqs.map((faq, index) => (
    <div
      key={index}
      className="bg-gray-900 rounded-lg shadow-md border border-white/10"
    >
      <button
        onClick={() => toggleFAQ(index)}
        className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none"
      >
        <span className="font-medium">{faq.question}</span>
        <FiChevronDown
          className={`transform transition-transform duration-200 ${
            openIndex === index ? "rotate-180" : ""
          }`}
        />
      </button>
      {openIndex === index && (
        <div className="px-6 pb-4 text-white/70 text-sm">
          {typeof faq.answer === "string" ? <p>{faq.answer}</p> : faq.answer}
        </div>
      )}
    </div>
  ))}
</div>

      </section>
    </div>
  );
}
